module.exports = __webpack_public_path__ + "img/transitions-signature.fef11a96.svg";